import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';

export const getMentionsCount = async (user_id: string) => {
  const url = routes.api_v0_profiles_mention_count_path({
    subdomain_param: 'api',
    user_id: user_id,
  });
  const response = await fetchWithCsrf(url);

  if (response.status !== 200) {
    throw new Error(`Unable to fetch mentions count`);
  }

  const data = await response.json();

  return parseInt(data.total_count, 10);
};

// Citations + Mentions counts for the profile owner, using the Citations
// Dashboard's category logic. Only succeeds for viewers in a dashboard variant
// (the endpoint 403s otherwise); callers gate on the server-rendered placeholder.
export const getCitationsDashboardCounts = async (user_id: string) => {
  const url = routes.api_v0_profiles_citations_dashboard_counts_path({
    subdomain_param: 'api',
    user_id: user_id,
  });
  const response = await fetchWithCsrf(url);

  if (response.status !== 200) {
    throw new Error(`Unable to fetch citations dashboard counts`);
  }

  const data = await response.json();

  return {
    citations: parseInt(data.citations, 10),
    mentions: parseInt(data.mentions, 10),
  };
};
